export default __webpack_public_path__ + "static/media/checkout.75bf430e.svg";